import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {TOTAL_DETAIL} from './constant';
import Checkbox from "../../../../components/checkbox";
import _ from 'lodash';

function TargetCondition(props) {
    const {selected} = props;
    const atBatRef = useRef();
    const overBatRef = useRef();
    const moreThanPickRef = useRef();

    const dataSearch = useSelector(state => state.detailSearch);
    const [listTarget, setListTarget] = useState({
        ruleAtBat: selected.ruleAtBat,
        atBat: null,
        overBat: null,
        moreThanAPick: null
    });
    const [isCheckAtBat, setIsCheckAtBat] = useState(false);
    const [isCheckOverBat, setIsCheckOverBat] = useState(false);
    const [isCheckMorePick, setIsCheckMorePick] = useState(false);
    const batData = [30,50,100,200,300];
    const moreThanAPickData = [50,100,200,300,1000];

    useEffect(() => {
        if(selected.atBat) {
            setIsCheckAtBat(true);
            atBatRef.current.value = selected.atBat;
        }
        if(selected.overBat) {
            setIsCheckOverBat(true);
            overBatRef.current.value = selected.overBat;
        }
        if(selected.moreThanAPick) {
            setIsCheckMorePick(true);
            moreThanPickRef.current.value = selected.moreThanAPick;
        }
    },[selected])
    useEffect(() => {
        props.onChange(listTarget)
    }, [listTarget])
    useEffect(() => {
        if(isCheckAtBat){
            if(_.isEmpty(listTarget.atBat)){
                const val = Number(atBatRef.current.value);
                setListTarget(state => ({...state, atBat: val}))
            }
        }else {
            setListTarget(state => ({...state, atBat: null}))
        }
    },[isCheckAtBat])

    useEffect(() => {
        if(isCheckOverBat){
            if(_.isEmpty(listTarget.overBat)){
                const val = Number(overBatRef.current.value);
                setListTarget(state => ({...state, overBat: val}))
            }
        }else {
            setListTarget(state => ({...state, overBat: null}))
        }
    },[isCheckOverBat])

    useEffect(() => {
        if(isCheckMorePick){
            if(_.isEmpty(listTarget.moreThanAPick)){
                const val = Number(moreThanPickRef.current.value);
                setListTarget(state => ({...state, moreThanAPick: val}))
            }
        }else {
            setListTarget(state => ({...state, moreThanAPick: null}))
        }
    },[isCheckMorePick])

    const onChangeAtBat = useCallback((e) => {
        if(!isCheckAtBat) setIsCheckAtBat(true);
        const value = Number(e.target.value);
        setListTarget(state => ({...state, atBat: value}))
    },[])

    const onChangeOverBat = useCallback((e) => {
        if(!isCheckOverBat) setIsCheckOverBat(true);
        const value = Number(e.target.value);
        setListTarget(state => ({...state, overBat: value}))
    },[])

    const onChangeMorePitch = useCallback((e) => {
        if(!isCheckMorePick) setIsCheckMorePick(true);
        const value = Number(e.target.value);
        setListTarget(state => ({...state, moreThanAPick: value}))
    },[])

    return <></>

    // eslint-disable-next-line no-unreachable
    return <div className='item-group-btn'>
        <h3 className='navbar-item'>抽出条件</h3>
        <div className='inner-item-group'>
            <div className='search-main-advanced-checkbox'>
                <label>
                    <Checkbox checked={listTarget.ruleAtBat} onClick={() => setListTarget({...listTarget, ruleAtBat: !listTarget.ruleAtBat})}/>
                    {(dataSearch[TOTAL_DETAIL.TYPE] === 'pitchers') ? '規定投球回到達者': '規定打席到達者'}
                </label>
            </div>
            <div>
                <div className='search-main-advanced-checkbox'>
                    <label>
                        <Checkbox checked={isCheckAtBat} onClick={() => setIsCheckAtBat(!isCheckAtBat)}/>
                    </label>
                </div>
                <select className='form-control select-custome' onChange={onChangeAtBat} ref={atBatRef}>
                    {batData.map((item, index) => {
                        return <option key={index}>{item}</option>
                    })}
                </select>
                <span>打席以上</span>
            </div>
            <div>
                <div className='search-main-advanced-checkbox'>
                    <label>
                        <Checkbox checked={isCheckOverBat} onClick={() => setIsCheckOverBat(!isCheckOverBat)}/>
                    </label>
                </div>
                <select className='form-control select-custome' onChange={onChangeOverBat} ref={overBatRef}>
                    {batData.map((item, index) => {
                        return <option key={index}>{item}</option>
                    })}
                </select>
                <span>打数以上</span>
            </div>
            <div>
                <div className='search-main-advanced-checkbox'>
                    <label>
                        <Checkbox checked={isCheckMorePick} onClick={() => setIsCheckMorePick(!isCheckMorePick)}/>
                    </label>
                </div>
                <select className='form-control select-custome' onChange={onChangeMorePitch} ref={moreThanPickRef}>
                    {moreThanAPickData.map((item, index) => {
                        return <option key={index}>{item}</option>
                    })}
                </select>
                <span>投球以上</span>
            </div>
        </div>
    </div>
}

export default TargetCondition;
